// extracted by mini-css-extract-plugin
export default {"inputComp":"Style_inputComp__ovzJm","readOnlyClass":"Style_readOnlyClass__sp-RJ","ErrorField":"Style_ErrorField__PBC+z"};